module.exports = __webpack_public_path__ + "static/img/coupon.7ac9fd4d.png";